type noop = () => void;
export const noop: noop = () => undefined;
